import script from "./calendar.vue?vue&type=script&setup=true&lang=js"
export * from "./calendar.vue?vue&type=script&setup=true&lang=js"

import "./calendar.vue?vue&type=style&index=0&id=699cedc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-699cedc4"]])

export default __exports__